import { useMutation, useQuery } from "@apollo/client";

import { TLoadoutsQuery } from "MVVM/Views/CreateMontage/@types";
import {
  LOADOUT_QUERY,
  ME_QUERY,
  QUICK_EDIT_GET_MOMENT,
} from "MVVM/GraphQL/quickEdit";
import { MOMENT_CREATE_CLIP } from "MVVM/GraphQL/mutations/momentRequestClip";

export type TQuickEditMoment = {
  id: string;
  title: string;
  timelineLabel: string;
  game: string;
  type: "primary" | "secondary" | "secondary_fail";
  match: {
    id: string;
  };
  clip: {
    id: string;
  };
  victimData: {
    team: string;
    gameId: string;
    displayName: string;
    avatar: string;
    user: {
      _id: string;
      username: string;
    };
  }[];
  icons: string[];
  player: {
    avatar: string;
    displayName: string;
    gameId: string;
    team: string;
    user: {
      _id: string;
      username: string;
    };
  };
};

export const QuickEditViewModel = (momentId: string) => {
  const { data: loadoutsData } = useQuery<TLoadoutsQuery>(LOADOUT_QUERY, {});
  const { data: momentData } = useQuery<{ moment: TQuickEditMoment }>(
    QUICK_EDIT_GET_MOMENT,
    {
      variables: { id: momentId },
      skip: !momentId,
    },
  );
  const { data: viewerData } = useQuery<{
    me: {
      mediaUploadUrl: {
        fields: {
          name: string;
          value: string;
        }[];
        key: string;
        url: string;
      };
    };
  }>(ME_QUERY, {
    fetchPolicy: "network-only",
  });

  const [momentCreateClip] = useMutation(MOMENT_CREATE_CLIP, {
    onError: (err: any) => {
      console.log(`mutateReaction error! ${err.message}`);
    },
  });
  const loadouts = loadoutsData?.loadouts;
  const moment = momentData?.moment;
  const mediaUploadUrl = viewerData?.me.mediaUploadUrl;

  return {
    loadouts,
    moment,
    momentCreateClip,
    mediaUploadUrl,
  };
};
